import {Eventify} from './Eventify.js';
import {OptionToggle} from './OptionToggle.js';
import {PollRobotTemplate} from './PollRobotTemplate.js';
import {VeejayAdminChannel} from './VeejayAdminChannel.js';

export class VeejayAdmin extends HTMLElement {
	computeChannel(el, attr=`data-channel`) {
		let channel = el.getAttribute(attr);
		if (!channel || ``==channel) {
			let pathParts = document.location.pathname.split(`/`);
			channel = pathParts[pathParts.length-1];
			if (``==channel && 1<pathParts.length) {
				channel=pathParts[pathParts.length-2];
			}
			if (``==channel) {
				console.log(`VeejayAdmin: you MUST set a data-channel, or have a valid ending path element`);
				// alert(`data-channel invalid`);
				return;
			}
		}		
		return channel;
	}
	constructor() {
		super();
		this.shadow = this.attachShadow({mode:`open`});
		[this.el,this.$] = PollRobotTemplate(`VeejayAdmin`);
		console.log(`VeejayAdmin constructor`);
	}
	connectedCallback() {
		console.log(`VeejayAdmin.connectedCallback()`);
		this.shadow.appendChild(this.el);
		Eventify(this.shadow, this);
		this.$.url.value=`https://www.aiki.co.za`;
		this.sharing = false;
		new VeejayAdminChannel();
		this.channel = this.computeChannel(this, `data-channel`);
	}
	share() {
		if (this.sharing) {
			this.close();
			return;
		}
		let u = this.$.url.value;
		let action = this.$.action.value;
		console.log(`VeejayAdmin::share: ${u}, action=${action}`);
		fetch(`/veejay/show/${this.channel}/js`, {
			method: `POST`,
			body: JSON.stringify(
				{
					url: u,
					action: action,
				})
		}).then(
			()=>{
				this.sharing = u;
				this.$.share_button.innerText = `Close`;
			});
	}
	breakouts() {
		console.log(`VeejayAdmin::breakouts`);
		fetch(`/veejay/breakouts/${this.channel}/js`, {
			method: `POST`,
			body: JSON.stringify(
			{
				channel: this.channel,
				action: `breakouts`,
			})
		}).then(
			()=>{
				console.log(`showed breakouts`);
			}).catch(err=>console.error(err));
	}
	hide_breakouts() {
		fetch(`/veejay/breakouts/${this.channel}/hide/js`, {
			method: `POST`,
			body: JSON.stringify(
			{
				channel: this.channel,
				action: `breakouts`,
			})
		}).then(
			()=>{
				console.log(`hid breakouts`);
			}).catch(err=>console.error(err));
	}
	close() {
		let u = this.$.url.value;		
		console.log(`Going to close `, u);
		fetch(`/veejay/close/${this.channel}/js`, {
			method: `POST`,
			body: JSON.stringify(
			{
				url: u,
			})
		}).then(
		()=>{
			this.sharing = false;
			this.$.share_button.innerText = `Share`;
		});
	}
}
customElements.define(`veejay-admin`, VeejayAdmin);